//styles/footerStyle.js

export const footerContainer = (theme) => ({
  backgroundColor: theme.palette.background.subtle,
  color: theme.palette.text.primary,
  paddingY: theme.spacing(3),
});

export const feedbackBubble = (theme) => ({
  color: theme.palette.primary.main,
  "&:hover": {
    color: theme.palette.primary.dark,
  },
});

export const footerStack = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  justifyContent: "center",
  gap: 2,
};

export const footerLink = (theme) => ({
  fontFamily: theme.typography.fontFamily,
  color: theme.palette.text.primary,
  textDecoration: "none",
  "&:hover": {
    color: theme.palette.primary.main,
    textDecoration: "underline",
  },
});

export const footerCopyright = (theme) => ({
  fontFamily: theme.typography.fontFamily,
  mt: theme.spacing(2),
  color: theme.palette.text.secondary,
});
